/** Trip-wide currency chosen on the Pricing step and applied across the wizard. */

export const getTripCurrency = (formData) => {
    const fromPricing = formData?.pricing?.currency;
    const fromPackages = formData?.packages?.currency;
    return String(fromPricing || fromPackages || '').trim();
};

const syncRepeatableCurrency = (stepData, repeatableKey, currency) => {
    if (!stepData || !Array.isArray(stepData[repeatableKey])) {
        return stepData;
    }

    return {
        ...stepData,
        [repeatableKey]: stepData[repeatableKey].map((item) => ({
            ...(item || {}),
            currency,
        })),
    };
};

export const applyTripCurrencyToFormData = (formData, currency) => {
    const normalized = String(currency || '').trim();
    if (!normalized || !formData) return formData;

    return {
        ...formData,
        pricing: { ...(formData.pricing || {}), currency: normalized },
        packages: { ...(formData.packages || {}), currency: normalized },
        services: syncRepeatableCurrency(formData.services, 'services', normalized),
        addons: syncRepeatableCurrency(formData.addons, 'addons', normalized),
        allocations: syncRepeatableCurrency(formData.allocations, 'allocations', normalized),
    };
};
